
// when user logged in, use api key
export const GET_CATEGORIES_V1 = "/categoryapi/getcategories";
// when user is not logged in, without api key
export const GET_CATEGORIES = "/categoryapi/getcategories";
export const GET_CITIES = "/cityapi/getcities";
export const GET_COUNRIES = "/constantapi/getcountries";
export const GET_ESTIMATED_PRICE = "/categoryapi/getcategories";
export const GET_ESTIMATE_PACKAGE_TRIP_FARE =
  "/tripapi/estimatepackagetripfare";
export const GET_ESTIMATE_TRIP_FARE = "/tripapi/estimatetripfare";
export const SAVE_TRIP = "/tripapi/save";
export const UPDATE_TRIP = "/tripapi/updatetrip";
export const GET_TRIPS = "/tripapi/gettrips";
export const FORGOT_PASSWORD = "//userapi/forgetpassword";
export const REGISTER_USER = "/userapi/registration";
export const USER_LOGIN = "/userapi/login";
export const USER_PHONE_LOGIN = "/userapi/phlogin";
export const GET_CONSTANTS = "/constantapi/getconstants";
export const USER_PHONE_REGISTRATION = "/userapi/phregistration";
export const UPDATE_USER_PASSWORD = "/userapi/updateuserpassword";
export const UPDATE_USER_PROFILE = "/userapi/updateuserprofile";
export const ADD_TRANS_WITHOUT_TRIP = "/tronsactionapi/addtranswithouttrip";
export const GET_TRANSACTIONS = "/tronsactionapi/gettransactions";
export const GET_NEARBBYDRIVERLISTS = "/driverapi/getnearbydriverlists"

/*Boarding & Dropping */
export const GET_BOARDING_DROPPING_POINTS = `/categoryapi/getboarddroppoints`
export const GET_VALIDATE_PROMO = '/promoapi/validatepromos'
export const GET_RAZORPAY_ORDER = '/tronsactionapi/create_razorpay_order'
export const GET_TRIP_RAZORPAY_ORDER = '/tronsactionapi/create_trip_razorpay_order'
export const GET_RAZORPAY_PAYMENT_VERIFY = '/tronsactionapi/verify_razorpay_payment'
export const GET_RAZORPAY_KEYS = "/constantapi/getrazorpaykeys"
export const SAVE_TRANSACTION = '/tronsactionapi/addtriptrans'
export const SAVE_TRANSACTION_V1 = '/tronsactionapi/addtriptransv1'
export const SAVE_TRIP_NOTIFICATION_SEND = "/tripapi/sendnotificationontripsave"
export const GET_SEAT_AVAILABLE_CHECK = '/categoryapi/checkseatavaiblecategory'
export const GET_ALL_IN_ONE_DATA = '/commonApi/getallinone'
export const GET_USER = '/userapi/getusers'
export const SAVE_TRIP_WITH_TRANS = '/tripapi/savewithtrans'
export const SAVE_MTRIP_CATEGORY = '/mtripapi/postsavemtrips'
export const GET_EDIT_CATEGORIES = "/categoryapi/geteditcategories";
export const SAVE_CATEGORIES = "/categoryapi/postsavecategories";
export const UPDATE_CATEGORIES = "/categoryapi/updatecategories";
export const GET_CATEGORIES_STOP_OVERS = '/categorystopoversapi/getcategorystopovers'
export const GET_CATEGORIES_STOPS = '/categorystopsapi/getcategorystops'
export const GET_CARS = '/carapi/getcars'
export const GET_CATEGORIES_SEARCH_RIDE = '/categoryapi/searchride'

// Ride Posts
export const SAVE_RIDE_POSTS = "/ridepostapi/postsaverideposts";
export const UPDATE_RIDE_POSTS = "/ridepostapi/updaterideposts";
export const GET_RIDE_BOARDING_DROPPING_POINTS = `/ridepostapi/getboarddroppoints`
export const GET_RIDE_POSTS = "/ridepostapi/getrideposts";
export const GET_RIDE_POST_SEARCH_RIDE = '/ridepostapi/searchride';
export const GET_CATEGORY_TAGS = "/constantapi/getcategorytags"
export const GET_LOCALISATIONS = "/localisationapi/getlocalisations"